module.exports = __webpack_public_path__ + "static/img/bg-pt.aeae0267.png";